module.exports = __webpack_public_path__ + "static/media/hospital.b037bbaf.jpg";